import './Tutor.css';
import pdfIcon from '../assets/PDF_file_icon.svg';
import react from '../assets/files/react.pdf';
import { useState } from 'react';  // stan pdfLeftStr


// komponent Tutor
export default function Tutor(){

  const [pdfLeftStr, setPdfLeftStr] = useState("10px"); // pamiętamy stan pdfLeftStr

  // zmieniamy stan pdfLeftStr
  let mouseOverMaterialy = () =>{
   //setInterval(() => {                                       
      setPdfLeftStr(Math.floor(Math.random()*700 +1) + "px");
   // }, 1000);
  }

  // zmieniamy stan pdfLeftStr
  let mouseOutMaterialy = () =>{
    setPdfLeftStr(Math.floor(Math.random()*700 +1) + "px");
  }


  return (
    <div id="pdf" style={{left: pdfLeftStr}}  onMouseOver = {()=>mouseOverMaterialy()}  onMouseOut = {()=>mouseOutMaterialy()}>
      <a  href={react} target="_blank" rel="noreferrer"><img src={pdfIcon.toString()} width="50px" alt="PDF icon"></img></a>
    </div>
  )
}